/**
 * Prev/next resolution for the media detail modals (ZPL-267). Navigation
 * cycles ONLY through items the modal can actually render — image/video
 * kinds with a source — skipping url/pdf kinds, which open in new tabs and
 * never appear in the modal. Wraps around; returns null when there is
 * nothing to navigate to (single viewable item, or the active item vanished
 * from a live refetch).
 */
export function modalNeighbors<
	T extends { id: string; kind: string; sourceUrl: string | null },
>(items: readonly T[], activeId: string): { prev: T; next: T } | null {
	const viewable = items.filter(
		(i) => (i.kind === "image" || i.kind === "video") && i.sourceUrl !== null,
	)
	const index = viewable.findIndex((i) => i.id === activeId)
	if (index === -1 || viewable.length < 2) return null
	return {
		prev: viewable[(index - 1 + viewable.length) % viewable.length],
		next: viewable[(index + 1) % viewable.length],
	}
}
